import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const qualifikationen = [
  "Financial Planner (EBS)",
  "Unabhängiger Finanz- und Versicherungsmakler (§ 34d Abs. 1 GewO)",
  "Unabhängiger Finanzanlagenvermittler (§ 34f Abs. 1 Nr. 1 GewO)",
  "Registriert bei der IHK für München und Oberbayern",
];

export const UeberMich = () => (
  <section id="ueber-mich" data-testid="ueber-mich-section" className="bg-white py-24 lg:py-32 border-t border-petrol/10">
    <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 px-4 sm:px-8 lg:px-16 items-center">
      <div className="lg:col-span-5 flex lg:justify-center">
        <Reveal className="w-full max-w-[220px]">
          <div className="relative">
            <div className="absolute -top-4 -left-4 h-full w-full border border-gold/50" aria-hidden="true" />
            <img
              src="/images/romeo-gordack.png"
              alt="Romeo Gordack — Financial Planner (EBS), FIPLAGO Rosenheim"
              className="relative aspect-[4/5] w-full object-cover object-center"
              data-testid="ueber-mich-photo"
            />
            <div className="absolute -right-8 -bottom-8 bg-white/85 backdrop-blur-md border border-petrol/10 px-3 py-2 shadow-lg shadow-petrol/5" data-testid="ueber-mich-badge">
              <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-forest">Ihr Ansprechpartner</p>
              <p className="font-display text-sm font-semibold text-petrol mt-0.5">Romeo Gordack</p>
              <p className="text-[10px] text-slate-500 mt-0.5">Financial Planner (EBS)</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="eyebrow mb-4">Persönlich & unabhängig</p>
          <p className="mt-2 max-w-2xl text-base leading-relaxed text-slate-600">
            Kein Callcenter, kein Vertrieb — Sie sprechen direkt mit mir. Als
            unabhängiger Finanzplaner aus Rosenheim binde ich mich an kein
            Produkt und keinen Konzern: Ich analysiere Ihre Situation und
            zeige Ihnen, welches Abschreibungspotenzial sich daraus ergibt.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <ul className="mt-8 space-y-3" data-testid="ueber-mich-qualifikationen">
            {qualifikationen.map((q) => (
              <li key={q} className="flex items-start gap-3 text-sm sm:text-base text-slate-700">
                <Check size={16} className="mt-1 shrink-0 text-forest" />
                {q}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
